import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserType } from '../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  role?: UserType; // 'admin' | 'customer' - if set, only that role can access
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, role }) => {
  const { isAuthenticated, userType } = useAuth();

  if (!isAuthenticated) {
    let loginPath = '/admin/login';
    if (role === 'customer') loginPath = '/customer/login';
    else if (role === 'society_admin') loginPath = '/society/login';
    return <Navigate to={loginPath} replace />;
  }

  if (role && userType !== role) {
    let redirectTo = '/admin/dashboard';
    if (userType === 'customer') redirectTo = '/customer/dashboard';
    else if (userType === 'society_admin') redirectTo = '/society/overview';
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

